import React, { useState } from 'react';
import { Box, Button, Modal, Stack, TextField, Typography } from '@mui/material';
import { useAppDispatch } from '../../../app/hooks';
import { createApplicantAsync } from './applicantsSlice';
import { ApplicantCreatePayloadRequest } from '../../../generated/api';

const NewApplicantModal = () => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState<boolean>(false);
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [email, setEmail] = useState<string>('');

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4
  };

  const handleSubmit = () => {
    const data: ApplicantCreatePayloadRequest = { firstName, lastName, email };
    dispatch(createApplicantAsync(data));
    setFirstName('');
    setLastName('');
    setEmail('');
  };

  return (
    <Box marginTop={1} display="flex" justifyContent="center">
      <Button onClick={() => setOpen(true)} variant="contained">
        New applicant
      </Button>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={style}>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
              New Applicant
            </Typography>
            <Box display="flex" flexDirection="row" sx={{ gap: 1 }}>
              <TextField label="First Name" value={firstName} onChange={({ target }) => setFirstName(target.value)} />
              <TextField label="Last Name" value={lastName} onChange={({ target }) => setLastName(target.value)} />
            </Box>
            <TextField label="Email" value={email} onChange={({ target }) => setEmail(target.value)} />
            <Button variant="contained" onClick={handleSubmit}>
              Submit
            </Button>
          </Stack>
        </Box>
      </Modal>
    </Box>
  );
};

export default NewApplicantModal;
